import { StyleSizeType } from '../../../styles/enums';
import { GridSizePropsType } from '../enums';

export const DEFAULT_GRID_SIZES = [
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XSmall,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Small,
    [GridSizePropsType.TableSize]: StyleSizeType.Small,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Medium,
    [GridSizePropsType.TableSize]: StyleSizeType.Medium,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.Large,
    [GridSizePropsType.TableSize]: StyleSizeType.Large,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XLarge,
    [GridSizePropsType.TableSize]: StyleSizeType.Large,
  },
  {
    [GridSizePropsType.Breakpoint]: StyleSizeType.XXLarge,
    [GridSizePropsType.TableSize]: StyleSizeType.Large,
  },
];

export default {
  DEFAULT_GRID_SIZES,
};
